// extracted by mini-css-extract-plugin
module.exports = {"container":"WeeklyCalendar_container__2mPJY"};